import { useQuery } from '@tanstack/react-query';
import apiClient from '../config/api-client';
import { ApiDashboard } from '../constants/ApiDashboard';
import { DashboardResponse, NotificationResponse } from '../types/dashboard';
import { UseQueryOptions } from '../types/react-query';

export const useQueryDashboard = ({
  query,
  options,
}: {
  query: { userId: string };
  options?: UseQueryOptions<DashboardResponse>;
}) =>
  useQuery(
    ['dashboard'],
    () =>
      apiClient
        .get<unknown, { data: DashboardResponse }>(ApiDashboard.dashboard(query.userId))
        .then((res) => res.data),
    options,
  );

export const useQueryGetNotification = ({
    query,
    options,
  }: {
    query: { userId: string, take?: number, page?: number };
    options?: UseQueryOptions<NotificationResponse>;
  }) =>
    useQuery(
      ['getNotification'],
      () =>
        apiClient
          .get<unknown, { data: NotificationResponse }>(ApiDashboard.getNotification(query.userId, query.take, query.page))
          .then((res) => res.data),
      options,
    );

export const useQueryReadAllNotification = ({
  query,
  options,
}: {
  query: { userId: string };
  options?: UseQueryOptions<any>;
}) =>
  useQuery(
    ['readNotification'], 
    () =>
      apiClient
        .get<any>(ApiDashboard.readAllNotification(query.userId))
        .then((res) => res.data),
    options,
  );